import { render } from "./SearchResult.vue?vue&type=template&id=9896cf64&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"

import "./SearchResult.vue?vue&type=style&index=0&id=9896cf64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9896cf64"

export default script